import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = BASE ? `${BASE}/api` : "";

export const visitorId = () => {
  let v = localStorage.getItem("oc_visitor");
  if (!v) {
    v = (window.crypto?.randomUUID?.() || String(Math.random()).slice(2)) + "";
    localStorage.setItem("oc_visitor", v);
  }
  return v;
};

export const api = axios.create({ baseURL: API || undefined, timeout: 60000, withCredentials: true });
api.interceptors.request.use((c) => { c.headers["X-Visitor-Id"] = visitorId(); return c; });

export const fmt = (s) => {
  const v = Number.isFinite(s) ? Math.max(0, s) : 0;
  return `${Math.floor(v / 60)}:${String(Math.floor(v % 60)).padStart(2, "0")}`;
};

export const asList = (res) => (Array.isArray(res?.data) ? res.data : []);

export async function streamPost(path, body, onText) {
  if (!API) throw new Error("No backend");
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", "X-Visitor-Id": visitorId() },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const d = await res.json().catch(() => ({}));
    throw new Error(typeof d?.detail === "string" ? d.detail : "The signal broke. Try again.");
  }
  const reader = res.body.getReader();
  const dec = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += dec.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      const line = ev.replace(/^data: /, "");
      if (line === "[DONE]") return;
      try {
        const j = JSON.parse(line);
        if (j.error) throw new Error(j.error);
        if (j.t) onText(j.t);
      } catch (e) {
        if (e.message && !(e instanceof SyntaxError)) throw e;
      }
    }
  }
}
